import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { MatRadioModule } from '@angular/material/radio';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'filtro-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss'],
  imports: [CommonModule, ModulosDeFormulario, MatRadioModule],
})
export class ClientesComponent implements OnInit {
  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();
  @Output('closeFilter') fechaFiltro = new EventEmitter();

  public orderBy: string = 'nome';

	fg_clientes: UntypedFormGroup;

  constructor(public filtroController: FiltroControllerService) {
	this.orderBy = this.filtroController?.filtroClientes?.orderBy ?? 'nome';
		this.fg_clientes = new UntypedFormGroup({
			filtroBusca: new UntypedFormControl(this.filtroController.filtroClientes?.filtroBusca ? this.filtroController.filtroClientes?.filtroBusca : ''),
			orderBy: new UntypedFormControl(this.filtroController.filtroClientes?.orderBy ? this.filtroController.filtroClientes?.orderBy : 'nome'),
			ativo: new UntypedFormControl(this.filtroController.filtroClientes?.ativo ? this.filtroController.filtroClientes?.ativo : 'ativos'),
			favorito: new UntypedFormControl(this.filtroController.filtroClientes?.favorito ? this.filtroController.filtroClientes?.favorito : 'todos'),
			periodo: new UntypedFormControl(this.filtroController.filtroClientes?.periodo ? this.filtroController.filtroClientes?.periodo : 'qualquer'),
			rotuloPeriodo: new UntypedFormControl(this.filtroController.filtroClientes?.rotuloPeriodo ? this.filtroController.filtroClientes?.rotuloPeriodo : 'Período'),
			// data de atualização mais antiga
			dataIni: new UntypedFormControl(this.filtroController.filtroClientes?.dataIni ? this.filtroController.filtroClientes?.dataIni : ''),
			// data de atualização mais recente
			dataFim: new UntypedFormControl(this.filtroController.filtroClientes?.dataFim ? this.filtroController.filtroClientes?.dataFim : ''),
			// data de atualização mais antiga (SQL)
			creationPeriodBegin: new UntypedFormControl(this.filtroController.filtroClientes?.creationPeriodBegin ? this.filtroController.filtroClientes?.creationPeriodBegin : undefined),
			// data de atualização mais recente (SQL)
			creationPeriodEnd: new UntypedFormControl(this.filtroController.filtroClientes?.creationPeriodEnd ? this.filtroController.filtroClientes?.creationPeriodEnd : undefined),
			// data de atualização mais antiga (SQL)
			updatePeriodBegin: new UntypedFormControl(this.filtroController.filtroClientes?.updatePeriodBegin ? this.filtroController.filtroClientes?.updatePeriodBegin : undefined),
			// data de atualização mais recente (SQL)
			updatePeriodEnd: new UntypedFormControl(this.filtroController.filtroClientes?.updatePeriodEnd ? this.filtroController.filtroClientes?.updatePeriodEnd :  undefined),
			page: new UntypedFormControl(1),
			limit: new UntypedFormControl(40),
		});
	}

  readonly options = [
    {
      value: 'nome',
      label: 'Nome',
    },
    {
      value: 'createdAtAsc',
      label: 'Data de criação crescente',
    },
    {
      value: 'createdAtDesc',
      label: 'Data de criação decrescente',
    },
    {
      value: 'updatedAtDesc',
      label: 'Data de modificação decrescente',
    },
    {
      value: 'updatedAtAsc',
      label: 'Data de modificação crescente',
    },
  ];

  ngOnInit() {}

  buildString() {
	console.log('buildString clientes', this.fg_clientes.getRawValue());

	const object = {orderBy: this.orderBy}

    this.filtroController.addFiltrosExtras('clientes', object);
    let filtros = { values: object };
    this.eventFilter.emit(filtros);
    this.filtroController.verificaFiltro();
	return filtros;
  }

  clearFilter() {
    this.orderBy = 'nome';
    this.filtroController.limparFiltro('clientes');
    this.filtroController.verificaFiltro();
    this.limpaFiltro.emit();
    this.buildString();
  }

  onRadioClick(event: any, value) {
	this.orderBy = value;
  }
}
